import script from "./IsbnFormTags.vue?vue&type=script&setup=true&lang=js"
export * from "./IsbnFormTags.vue?vue&type=script&setup=true&lang=js"

import "./IsbnFormTags.vue?vue&type=style&index=0&id=5740529d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5740529d"]])

export default __exports__